<template>
  <div class="vacancy">
    <div class="vacancy__header header">
      <div class="header__checkbox">
        <Checkbox
          :value="Number(selected)"
          :disabled="checkboxDisabled"
          @change="
            val => {
              selected = Boolean(val);
            }
          "
        />
      </div>
      <div class="header__title">
        <a :href="viewRoute">
          <h3 class="header__title-text primary">
            {{ vacancy.name.value || '[нет наименования]' }}
          </h3>
        </a>
        <span
          contenteditable
          class="header__title-description"
          type="text"
          data-placeholer="Введите"
          @keydown="inputHandler"
          @blur="userFieldHandler"
          v-html="$sanitize(vacancy.hrpac_vacancy_user_name.value)"
        />
      </div>
    </div>
    <div class="header__tags">
      <Tag
        v-if="vacancy.status_id.value"
        :closable="false"
        :name="vacancy.status_id.value"
        size="middle"
        class="status-tag"
      />
      <Tag
        v-if="vacancy.reason_for_opening.value"
        :closable="false"
        :name="vacancy.reason_for_opening.value"
        size="middle"
        class="reason-tag"
      />
      <Tag
        v-show="vacancy.stack_skills_ids.value.length"
        v-for="(tag, index) in vacancy.stack_skills_ids.value.split(/,\s*/g)"
        :key="index"
        :closable="false"
        :name="tag"
        size="middle"
        class="skills-tags"
      />
    </div>
    <div class="vacancy__description description">
      <div class="description__part">
        <div
          v-for="name in editableFields"
          :key="name"
          class="description__items"
        >
          <p class="description__name primary">
            {{ vacancy[name].label_text }}:
          </p>
          <p class="description__name-value blue">
            {{
              `${vacancy[name].value} ${vacancy[name].after_placeholder || ''}`
            }}
          </p>
        </div>
      </div>
    </div>
    <Progressbar
      :stroke-width="12"
      :percentage="vacancy.progresbar.value"
      :show-text="false"
      class="vacancy__progressbar"
    />
  </div>
</template>

<script>
import Checkbox from 'Elements/Checkbox/CustomCheckbox';
import Tag from 'Elements/Tag/Tag';
import Progressbar from 'Elements/Progressbar/Progressbar';
import { store } from '@/store';
import { MODULE, ACTION } from '@/utils/constants';
import { detailView } from '@/utils/helpers';

export default {
  props: {
    vacancy: Object,
    editableFields: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    checkboxDisabled() {
      return (
        store.state.selectionPopup.attachingCandidates == true &&
        store.state.common.selected.length > 0 &&
        !store.state.common.selected.includes(this.vacancy.id.value)
      );
    },
    config() {
      return store.state.common.config;
    },
    selected: {
      get() {
        return store.state.common.selected.includes(this.vacancy.id.value);
      },
      set(value) {
        const selected = value
          ? [this.vacancy.id.value]
          : store.state.common.selected.filter(
              id => id !== this.vacancy.id.value
            );

        store.commit('common/setSelected', {
          arr: selected,
          replace: !value
        });
      }
    },
    viewRoute() {
      return detailView(MODULE.VACANCY_MODULE, this.vacancy.id.value);
    }
  },
  methods: {
    inputHandler(e) {
      if (e.keyCode == 13) e.preventDefault();
    },
    async userFieldHandler(e) {
      const options = new FormData();

      options.append('module', MODULE.VACANCY_MODULE);
      options.append('action', ACTION.SAVE);
      options.append('hrpac_vacancy_user_name', e.target.innerText.trim());
      options.append('record', this.vacancy.id.value);
      options.append('jsqon_return', 1);

      await store.dispatch('common/saveForm', { options });
    }
  },
  components: {
    Checkbox,
    Tag,
    Progressbar
  }
};
</script>

<style lang="scss">
.header__checkbox .el-checkbox.custom-checkbox {
  margin-bottom: 0px;
}
</style>

<style lang="scss" scoped>
.description {
  &__items {
    display: flex;
    margin-top: 4px;
    flex: 50%;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;

    p:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline;
    }

    &-name {
      margin: 0;
    }

    &-value {
      margin: 0;
    }
  }

  &__name,
  &__value {
    display: flex;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
  }

  &__name {
    margin-right: 4px;
  }

  &__part {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: -4px;
    width: 100%;
  }
}

.header {
  &__title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 16px;
    justify-content: space-between;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;

    &-text {
      margin: 0;
      line-height: 32px;
      font-size: 24px;
      font-weight: bold;
      // color: $black-90;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &-description {
      background: $yellow-10;
      padding: 4px 8px;
      font-size: 14px;
      line-height: 24px;
      border-radius: 4px;
      width: max-content;
      color: $yellow-160;
      border: none;
      min-width: 70px;
      text-align: left;
      outline: none;
      overflow: hidden;
      max-width: 100%;

      &:empty:not(:focus):not(:hover):before {
        content: attr(data-placeholer);
        color: $yellow-90;
        display: block;
      }
    }

    a {
      max-width: 100%;
    }
  }

  &__checkbox {
    display: flex;
    align-items: center;
    background: $black-10;
    min-width: 40px;
    justify-content: center;
    width: 40px;
    border-radius: 4px;
    cursor: pointer;

    &--blocked {
      cursor: default;
    }
  }

  &__tags {
    display: flex;
    margin-bottom: 16px;
    max-width: 100%;
    flex-wrap: wrap;

    .el-tag:last-child {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .el-tag:nth-child(-n + 3) {
      margin-bottom: 8px;
    }

    .status-tag,
    .reason-tag {
      margin-right: 24px;
    }

    .skills-tags {
      margin-right: 8px;
    }
  }
}

.vacancy {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 24px 24px 20px 24px;
  min-height: 228px;
  border-radius: 6px;
  box-shadow: 0 7px 9px rgba(0, 0, 0, 0.04);

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }

  &__header {
    display: flex;
    height: 76px;
    margin-bottom: 12px;
  }

  &__description {
    display: flex;
  }

  &__progressbar {
    margin-top: 20px;

    & ::v-deep .el-progress-bar {
      min-width: 100%;
    }
  }
}
</style>

<style lang="scss">
.vacancy__card {
  .el-progress-bar {
    min-width: 100%;

    .el-progress-bar__inner,
    .el-progress-bar__outer {
      border-radius: 4px;
    }
  }
}
</style>
